import {
  POST,
  GETPDF,
  GET
} from '@/axios/axios'

export const services = {
  ApplyForRegulate: (param) => {   // 申请记录
    return GET("/backend/orderMain/queryGrantPage", param);
  },
  DeriveApplication: (param, rsType) => {   // 申请记录导出
    return GETPDF('/backend/orderMain/orderExport', param, rsType);
  },
  OrderStatus: (param) => {   // 申请记录-交易订单列表-订单状态
    return GET('/backend/orderMain/queryStayOrder', param)
  },
  ModifyOrderStatus: (param) => {   // 申请记录-交易订单列表-修改订单状态
    return POST('/backend/orderMain/disOrderPayment', param)
  },
  CheckAuditStatus: (param) => {   // 审核状态
    return POST("/backend/orderMain/orderPayment", param);
  },
  DownloadInventory: (param, rsType) => {   // 下载拆分清单
    return GETPDF("/backend/accountPaymentDetail/paymentDetailExport", param, rsType);
  },
  ExamineStatement: (param) => {   // 查看结算单
    return GET("/backend/accountPaymentDetail/paymentDetail", param);
  },
  PayrollDetails: (param) => {   // 支付明细列表
    return GET("/backend/accountPaymentDetail/queryBalanceRecord", param);
  },
  PayingStatus: (param) => { // 更新支付中的数据
    return POST("/backend/accountPayment/updateOrderPayingStatus", param);
  },
  DetailsExport: (param, rsType) => {   // 支付明细导出
    return GETPDF('/backend/accountPaymentDetail/export', param, rsType);
  },
  TaskAcceptance: (param) => {   // 任务承接记录
    return GET("/backend/taskPublish/queryByPage", param);
  },
  TaskExport: (param, rsType) => { // 任务承接记录导出
    return GETPDF("/backend/taskPublish/export", param, rsType);
  },
  TaskFileReview: (param) => { // 验收文件核审列表
    return GET("/backend/orderPhaseRel/queryByPage", param);
  },
  TaskFileReviewEdit: (param) => { // 验收文件核验状态修改
    return POST("/backend/orderPhaseRel/updateOrderPhaseStatus", param);
  },
  TaskFileReviewExport: (param, rsType) => { // 验收文件导出
    return GETPDF("/backend/orderPhaseRel/export", param, rsType);
  },
  ProjectDetails: (param) => {   // 项目详情
    return GET("/backend/taskPublish/queryTaskInfoById", param);
  },
  ReviewRejected: (param) => {   // 复核驳回
    return POST("/backend/taskPublish/updateTaskStatus", param);
  },
  SuspendOrder: (param) => {   // 挂起订单列表
    return GET("/backend/orderDetail/queryStayOrder", param);
  },
  SuspendOrderUp: (param) => { //挂起订单列表
    return GET("/backend/custom/batchOfflineAuthentication", param);
  },
  SuspendOrderExport: (param, rsType) => {   // 挂起订单列表导出
    return GETPDF("/backend/orderDetail/queryStayOrderExport", param, rsType);
  },
  receiptImgShow: (param) => { // 电子回单
    return GET("/backend/accountPaymentDetail/downReceipt", param);
  },
  downloadReceipt: (param) => { // 电子回单批量下载按条件或者导出全部
    return GET("/backend/accountPaymentDetail/backstage/downloadReceipt", param);
  },
  thisDownloadReceipt: (param) => { // 电子回单批量下载按订单id导出
    return GET("/backend/accountPaymentDetail/backstage/thisDownloadReceipt", param);
  },
  refundExchange: (param) => { // 支付明细单笔退汇
    return POST("/backend/accountPaymentDetail/refundExchange", param);
  },
  msPaymentInfo: (param) => { // 民生预付退还信息列表
    return GET("/backend/orderMain/minShengPrePaymentInfo", param);
  },
  msPaymentDetail: (param) => { // 支付详情
    return GET("/backend/orderMain/minShengPaymentDetail", param);
  },
  msBatchData: (param) => { // 民生预付流水
    return GET("/backend/orderMain/minShengBatchData", param);
  },
  updateStatus: (param) => { // 变更预付状态 或 驳回
    return POST("/backend/orderMain/updatePrepaymentStatus", param);
  },
  updateRefund: (param) => { // 变更退还状态
    return POST("/backend/orderMain/updateRefundStatus", param);
  },
  offlinePayment: (param) => { // 转线下预付
    return POST("/backend/orderMain/offlinePrepayment", param);
  },
  premiumInfoPage: (param) => { // 对公手续费列表
    return GET("/backend/premium/premiumInfoPage", param);
  },
  autoTransfer: (param) => { // 批量转账
    return POST("/backend/premium/autoTransfer", param);
  },
  premiumTransfer: (param) => { // 手续费转账记录列表
    return GET("/backend/premium/premiumTransferPage", param);
  },
  batchTransfer: (param) => { // 转账或线下转账
    return POST("/backend/premium/batchTransfer", param);
  },
  offline: (param) => { // 线下转账
    return GET("/backend/premium/offline", param);
  },
  uploadVoucher: (param) => { // 上传凭证
    return POST("/backend/premium/uploadVoucher", param);
  },
  queryTaskType: () => { // 获取任务类型
    return GET("/backend/dataDict/queryTaskType");
  },
  NewMission: (param) => {   // 支付管理-新建任务
    return POST('/backend/taskPublish/updateTaskById', param)
  },
  updateReview: (param) => { // 后台任务启用、停用
    return POST("/backend/taskPublish/updateReviewStatus", param);
  },
  OrderPayment: (param) => { // 挂单记录列表
    return GET("/backend/orderDetail/listOrderDetailPayment", param);
  },
  updateAmount: (param) => { // 挂单记录-更新状态
    return POST("/backend/orderDetail/updateAmountEnough", param);
  },
  findAccountPushRecordList: (param) => { // 到账啦推送记录列表
    return GET("/backend/accountPaymentDetail/findAccountPushRecordList", param);
  },
  findAccountPushRecordListExport: (param) => { // 到账啦推送记录列表导出
    return GET("/backend/accountPaymentDetail/findAccountPushRecordListExport", param);
  },
  findRemittanceTableList: (param) => { // 民生退汇列表
    return GET("/backend/accountPaymentDetail/findRemittanceTableList", param);
  },
  remittanceByOrder: (param) => {   // 退汇审核
    return POST('/backend/accountPaymentDetail/remittanceByOrder', param)
  },
  remittanceByDetailNo: (param) => {   // 退汇录入
    return POST('/backend/accountPaymentDetail/remittanceByDetailNo', param)
  },
  personalProvideExport: (param, rsType) => {   // 个人发放数据导出
    return GETPDF('/backend/accountPaymentDetail/personalProvideExport', param, rsType);
  },
  queryTaskInfoByIdForExport: (param, rsType) => { // 任务承接记录-个人承接导出
    return GETPDF("/backend/taskPublish/queryTaskInfoByIdForExport", param, rsType);
  },
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/paymentmanage.js